import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Loader from "../../../../components/NewView/Common/Loader";
const GameMeetingComponent = React.lazy(() =>
  import("../../../../components/NewView/RootComponents/courses/publicCourses/GameMeetingComponent")
);
const GameMeetingPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>
          YellowHub
          </title>
          <meta
            name="description"
            content="Next LMS - Professional LMS Online Education Course
            React Template"
          />
        </Helmet>
        <GameMeetingComponent />
      </Suspense>
    </Fragment>
  );
};

export default GameMeetingPage;
